import { SITE_ORIGIN, HT } from "../siteConfig";
import SEO from "../components/seo.jsx"
import ogImage from "../assets/gallery/client2.jpeg"
import About from "./about"
import BeforeAfterGallery from "./gallery"
import Hero from "./hero"
import OurCenters from "./ourCenters"
import WhyChooseUs from "./whychooseus"
import YoutubeSection from "./youtube"


const home = () => {
  return (
    <>
<SEO
  title={`Sapphire FUE Hair Transplant in ${HT.placeName} | Clinique Internationale`}
  description={`Clinique Internationale offers advanced Sapphire FUE hair transplant & hair restoration in ${HT.placeName}, led by Dr. Bhavesh Gupta. Natural results, expert care — book your consultation.`}
  url={`${SITE_ORIGIN}/`}
  author="Clinique Internationale"
  image={new URL(ogImage, SITE_ORIGIN).href}
  keywords={`hair transplant in ${HT.placeName}, Sapphire FUE hair transplant ${HT.placeName}, hair transplant clinic in ${HT.placeName}, hair restoration ${HT.placeName}, hair transplant surgeon ${HT.placeName}, FUE hair transplant ${HT.placeName}, natural hair transplant ${HT.placeName}, Clinique Internationale`}
/>
    <Hero />
    <About />
    <WhyChooseUs />
    <BeforeAfterGallery/>
    <OurCenters />
    <YoutubeSection />
    </>
  )
}

export default home
